import React from 'react';
import './back-button.scss';

const BackButton = props => {

    const { title, onClick, className } = props;

    return (
        <a className={"f-back " + className} onClick={onClick} href="/">
            <span className="icon-left"></span><p>{title}</p>
        </a>
    )
}

export default BackButton;